<template>
  <v-app>
    <v-main>
      <div id="app" class="container-fluid">
        <div class="logo-container d-flex align-center">
          <img
            src="./assets/orchestra-logo.png"
            class="mr-auto"
            @click="$router.push('/')"
          />

          <v-btn
            class="mr-4"
            small
            text
            color="primary"
            to="/users"
            v-if="isLoggedIn && role == 'admin'"
            >Users</v-btn
          >

          <v-btn small text color="primary" v-if="isLoggedIn" @click="onLogout"
            >Logout</v-btn
          >
        </div>

        <transition name="component-fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import config from "./config.json";

export default {
  name: "App",
  mounted() {
    let version = JSON.parse(localStorage.getItem("version"));
    console.log(version);
    console.log(config.version);
    if (!version || version !== config.version) {
      console.log("new version uploaded, clearing local storage...");
      localStorage.clear();
      localStorage.setItem("version", JSON.stringify(config.version));

      this.$store.dispatch({ type: "resetAllSpaces" });
      this.$store.dispatch({ type: "resetEditingStep" });
      this.$store.dispatch({ type: "resetMyExperiences" });
      this.$store.dispatch({ type: "resetScene" });
      this.$store.dispatch({ type: "resetSpace" });
    }
  },
  computed: {
    ...mapState({
      role: (state) => state.auth.role,
    }),
    ...mapGetters(["isLoggedIn"]),
  },
  methods: {
    ...mapMutations(["logout"]),
    onLogout() {
      this.logout();
      this.$router.push({ path: "/login" });
    },
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

#app {
  font-family: "Ubuntu", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: #33363d;
  color: white;
  font-weight: 400;
  line-height: 1.5;
  position: relative;
  overflow-x: hidden;
  padding: 0;
}

.logo-container {
  position: absolute;
  top: 0;
  left: 0;
  padding: 15px;
  height: 80px;
  width: 100%;
  background: #33363d;
  z-index: 100;
  cursor: pointer;
}

.page-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.page-col {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.center-content {
  justify-content: center;
}

.wrap-items {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.break {
  flex-basis: 100%;
  height: 0;
}

.tool-wrapper {
  // margin-top: 10px;
  padding: 5px 0;
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}

.form-group {
  margin: 0 auto 15px;
  width: 80%;
}

.form-input {
  font-family: inherit;
  font-size: 16px;
  width: 100%;
  height: 44px;
  padding: 10px 8px;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  background-color: #292b31;
  color: white;
  text-align: center;
}

.form-input:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(92, 193, 166, 0.5);
}

.form-input::placeholder {
  color: #cccccc;
  opacity: 1;
}

.form-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cccccc;
}

.form-input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #cccccc;
}

.form-label {
  text-align: left;
  padding-bottom: 5px;
}

.input-error {
  box-shadow: 0 0 2px 2px #5cc1a6;
}

.view-title {
  margin: 0;
}

.title-input-container {
  position: absolute;
  left: 34%;
  top: 2%;
  z-index: 101;
}

.title-input {
  font-family: inherit;
  font-size: 16px;
  // width: 100%;
  height: 44px;
  padding: 10px 8px;
  border-radius: 4px;
  border: 1px solid #f2f2f2;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  text-align: center;
  text-overflow: ellipsis;
}

.title-input:focus {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(92, 193, 166, 0.5);
}

.title-input::placeholder {
  color: #cccccc;
  opacity: 1;
}

.title-input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #cccccc;
}

.title-input::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #cccccc;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}

.my-btn {
  font-family: inherit;
  background-color: #5cc1a6;
  border: 2px solid #5cc1a6;
  border-radius: 30px;
  width: 170px;
  height: 45px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  margin: 4px;
  transition: background-color 0.3s;
}

.my-btn:hover {
  background-color: #3fa68b;
  transition: background-color 0.3s;
}

.my-btn:focus {
  outline: none;
  border: 2px solid #3fa68b;
}

.my-tab {
  font-family: inherit;
  background-color: transparent;
  border: none;
  width: 160px;
  height: 45px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  transition: background-color 0.3s;
}

.my-tab:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transition: background-color 0.3s;
}

.my-tab:focus {
  outline: none;
}

.my-tab.active {
  border-bottom: 4px solid #5cc1a6;
}

.my-select {
  -webkit-appearance: none;
  appearance: none;
  font-family: inherit;
  font-size: 16px;
  color: #ffffff;
  height: 46px;
  padding: 5px 35px 5px 15px;
  border-radius: 3px;
  border: 1px solid #ffffff;
  width: 300px;
  box-shadow: inset 1px 1px 0px rgba(0, 0, 0, 0.15);
  background-color: transparent;
  background-image: url("./assets/select-down-arrow-white.svg");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) 16px;
  background-size: 16px 16px;
}

.my-select:focus {
  outline-color: #5cc1a6;
}

option {
  color: #ffffff;
  background-color: #33363d;
}

.modal-message {
  color: #5cc1a6;
  font-size: 14px;
  padding-top: 5px;
}

.node-icon {
  width: 100%;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

::-webkit-scrollbar {
  width: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #edf8f5;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5cc1a6;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #5cc1a6;
}

@media screen and (max-width: 768px) {
}

// @keyframes nodeInserted {
// 	from {
// 		opacity: 0.2;
// 	}
// 	to {
// 		opacity: 0.8;
// 	}
// }
// .item-dropzone-area {
// 	height: 6rem;
// 	background: #888;
// 	opacity: 0.8;
// 	animation-duration: 0.5s;
// 	animation-name: nodeInserted;
// 	margin-left: 0.6rem;
// 	margin-right: 0.6rem;
// }

.scrollable-dialog {
  height: 90vh;
}
.component-wrapper {
  height: 100vh;
  padding: 16px;
  padding-top: 96px;
  display: flex;
  flex-direction: column;
}
</style>
